/* Media with stats: the looping video only loads and plays when it's near the screen,
   pauses when scrolled away, and has a pause button. Visitors who prefer reduced motion
   see the cover image until they press play. */
(function () {
  'use strict';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(video) {
    if (video.dataset.mwsReady) return;
    video.dataset.mwsReady = '1';
    var btn = video.parentNode.querySelector('[data-mws-toggle]');
    var userPaused = reduce;
    var visible = false;

    function sync() {
      var paused = video.paused;
      if (!btn) return;
      btn.hidden = false;
      btn.classList.toggle('is-paused', paused);
      btn.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
    }
    function play() {
      var p = video.play();
      if (p && p.catch) p.catch(function () { sync(); });
    }

    video.addEventListener('play', sync);
    video.addEventListener('pause', sync);
    if (btn) {
      btn.addEventListener('click', function () {
        userPaused = !video.paused;
        if (userPaused) video.pause(); else play();
      });
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        if (visible && !userPaused) play();
        else if (!visible && !video.paused) video.pause();
      }, { rootMargin: '200px 0px' }).observe(video);
    } else if (!userPaused) {
      play();
    }
    sync();
  }

  function initAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-mws-video]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
